import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ThumbnailUploadResult } from '../interfaces/thumbnail.interface';

@Injectable({ providedIn: 'root' })
export class ThumbnailResource {
  private baseUrl = environment.apiUrl + '/s3';

  constructor(private httpClient: HttpClient) {}

  /**
   * Upload a thumbnail to S3
   * @param mapId The map ID (used as filename)
   * @param file The file to upload
   */
  upload(mapId: string, file: File): Observable<ThumbnailUploadResult> {
    const formData = new FormData();
    formData.append('file', file);

    return this.httpClient.post<ThumbnailUploadResult>(
      `${this.baseUrl}/upload`,
      formData,
      {
        params: {
          folder: 'smapshots',
          filename: `${mapId}.png`
        }
      }
    );
  }

  /**
   * Get a presigned URL for viewing a thumbnail
   * @param key The S3 key (e.g., smapshots/mapId.png)
   */
  getPresignedUrl(key: string): Observable<{ url: string }> {
    return this.httpClient.get<{ url: string }>(
      `${this.baseUrl}/presigned`,
      { params: { key } }
    );
  }

  /**
   * Delete a thumbnail from S3
   * @param key The S3 key to delete
   */
  delete(key: string): Observable<{ message: string }> {
    return this.httpClient.delete<{ message: string }>(
      `${this.baseUrl}/delete`,
      { params: { key } }
    );
  }

  /**
   * Set thumbnail URL for a map (only if not already set)
   * @param mapId The map ID
   * @param key The S3 key
   */
  setThumbnailUrl(mapId: string, key: string): Observable<{ thumbnailUrl: string }> {
    return this.httpClient.patch<{ thumbnailUrl: string }>(
      `${this.baseUrl}/thumbnail/${mapId}`,
      null,
      { params: { key } }
    );
  }
}
